import React from "react";
import { useStore } from "@/store/store";
import {
  formatDateValue,
  formatMoneyValue,
  formatNumberValue,
  getRuntimeLanguage,
  localeFor,
  normalizeLanguage,
} from "@/i18n/core";
import { localizeCatalogSource, translateKey } from "@/i18n/registry";

export { SUPPORTED_LANGUAGES, localeFor, normalizeLanguage } from "@/i18n/core";

export function currentLanguage() {
  return getRuntimeLanguage();
}

export function translate(key, params = {}, language = currentLanguage()) {
  return translateKey(key, params, language);
}

// Compatibility bridge for catalogued seed/import values. UI copy uses t()
// with stable keys so wording can change without changing code call sites.
export function localizeSource(source, params = {}, language = currentLanguage()) {
  return localizeCatalogSource(source, params, language);
}

export function useI18n() {
  const { state } = useStore();
  const language = normalizeLanguage(state.lang);
  return React.useMemo(() => {
    return {
      language,
      locale: localeFor(language),
      isGeorgian: language === "ka",
      t: (key, params) => translate(key, params, language),
      localize: (value, params) => localizeSource(value, params, language),
      formatNumber: (value, options) => formatNumberValue(value, language, options),
      formatDate: (value, options) => formatDateValue(value, language, options),
      formatMoney: (value) => formatMoneyValue(value, language),
    };
  }, [language]);
}

export function LanguageDocumentSync() {
  const { state } = useStore();
  const language = normalizeLanguage(state.lang);
  React.useLayoutEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dataset.locale = language;
  }, [language]);
  return null;
}
